import { motion } from "framer-motion";

/**
 * LoadingScreen — full-viewport loading state, used as the <Suspense>
 * fallback for lazy-loaded routes (Phase 4) and while auth state resolves.
 * Deliberately minimal — a spinner tied to the brand mark, no copy that
 * could feel like a "fake page".
 */
export default function LoadingScreen({ label = "Yuklanmoqda..." }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-brand-cream gap-4">
      <motion.div
        className="w-10 h-10 rounded-full border-[3px] border-brand-line border-t-brand-gold"
        animate={{ rotate: 360 }}
        transition={{ duration: 0.8, repeat: Infinity, ease: "linear" }}
      />
      <p className="text-body-sm text-brand-muted">{label}</p>
    </div>
  );
}
